<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates44">
<p class="centerImage"><img alt="images" id="plate44" src="images/plate44.jpg"/></p>
<p class="caption">A Mitsubishi Ki-21 ‘Sally’.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates44.vue?ffa21ad4